import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const UrgentRequestConfirmationModal = ({ visible, handleModalClose, handleUpdateSelectedCollection, type }) => {
  return (
    <Modal
      isOpen={visible}
      toggle={handleModalClose}
      style={{ maxWidth: "650px", marginTop: "100px" }}
    >
      <ModalHeader>Incomplete {`${type==="tank" ? "Tank Swap/Repair": "Urgent Collection"}`} Request</ModalHeader>
      <ModalBody>
        <p>
          {`You have not completed your ${type==="tank" ? "tank swap/repair" : "urgent collection"} request - Your request
          will not be processed. Do you wish to start a new request?`}
        </p>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-primary" onClick={handleUpdateSelectedCollection}>Yes</button>
        <button className="btn" onClick={handleModalClose}>No</button>
      </ModalFooter>
    </Modal>
  );
};
export default UrgentRequestConfirmationModal;
